'use client';

import { useEffect } from 'react';

import { SECRET_KEY, SSO_MAIL_KEY, SSO_USER_DATA } from '@constants/constants';
import useGetasPath from '@hooks/useGetasPath';
import { removeSafeLocalStorageItem } from '@utils/localStorage/getSafeLocalStorage';

// This hook's name clarifies itself
const usePathControl = () => {
  const asPath = useGetasPath();
  useEffect(() => {
    const currentPath = asPath;
    if (!currentPath.includes('/setur-extra')) {
      removeSafeLocalStorageItem(SECRET_KEY);
      removeSafeLocalStorageItem(SSO_MAIL_KEY);
      removeSafeLocalStorageItem(SSO_USER_DATA);
    }
  }, [asPath]);
};

export default usePathControl;
